import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { ENTER } from '@angular/cdk/keycodes';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonModelService } from '../../../../../padu-reporting/capability/common-model.service';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatOption } from '@angular/material/select';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';

@Component({
    selector: 'app-edit-segment',
    templateUrl: './edit-segment.component.html',
    styleUrl: './edit-segment.component.css',
    imports: [FormsModule, MatFormField, MatChipGrid, MatChipRow, MatIcon, MatChipRemove, MatAutocompleteTrigger, MatChipInput, MatAutocomplete, MatOption]
})
export class EditSegmentComponent implements OnChanges, OnInit {

  @Input() isEditSegment:any;
  @Input() editSegmentDataSource:any;
  
  @Output() SegmentEditById: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputAddOwner') inputAddOwner: any;
  @ViewChild('inputAddDelegate') inputAddDelegate: any;

  private subject: Subject<string> = new Subject();
  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  segmentData = [];
  inputElement: any;
  users: any = [];
  separatorKeysCodes: number[] = [ENTER];
  AddSegmentUpdate = {
    'FundingOwner': [],
    'FundingSegment': []
  };
  disableEditSegment: boolean = true;
  fundingSegment: any = '';
  editData: any;
  EditSegmentData = {
    'add': [],
    'remove': []
  }

  constructor(
    public dialog: MatDialog,
    private capabilityService: CommonModelService,
    private toastrService: ToastrService,
    private maintemceService: MaintenanceService) { }

    ngOnInit(): void {
      console.log('Edit Segment Data:', this.editSegmentDataSource);
      this.subject.pipe(
        debounceTime(500)
      ).subscribe(searchObj => {
        this.handleSearch(searchObj);
      });
      // this.getSegmentDetailsById();
    }
  
    ngOnChanges() {
      this.subject.pipe(
        debounceTime(500)
      ).subscribe(searchObj => {
        this.handleSearch(searchObj);
      });
      this.getSegmentDetailsById();
    }

    getSegmentDetailsById() {
      if (this.editSegmentDataSource) {
        this.editData = this.editSegmentDataSource;
        this.fundingSegment = this.editSegmentDataSource.Funding_Segment;
        this.AddSegmentUpdate.FundingOwner = this.editSegmentDataSource.Funding_Owner;
        this.AddSegmentUpdate.FundingSegment = this.editSegmentDataSource.Funding_Delegate;
        this.EditSegmentData.add = [];
        this.EditSegmentData.remove = [];
        this.disableAddSegment();
      }
    }

  
    removeOwnerAndDeligate(user, role) {
      user['role'] = role;
      if (role === 'Funding_Owner') {
        const index = this.AddSegmentUpdate.FundingOwner.indexOf(user);
        if (index >= 0) {
          this.AddSegmentUpdate.FundingOwner.splice(index, 1);
        }
      }
      else {
        const index = this.AddSegmentUpdate.FundingSegment.indexOf(user);
        if (index >= 0) {
          this.AddSegmentUpdate.FundingSegment.splice(index, 1);
        }
      }
      let existFlag = false;
      this.EditSegmentData.add.forEach(row => {
        if (user.msid === row.msid && user.role === row.role){
          const index = this.EditSegmentData.add.indexOf(row);
          if (index >= 0) {
            this.EditSegmentData.add.splice(index, 1);
            existFlag = true;
          }
        }
      })
      if (!existFlag){
        this.EditSegmentData.remove.push({
          'employeeID' : user.employeeID,
          'MSId' : user.msid || user.MSId,
          'role' : user.role
        });
      }
      this.disableAddSegment();
    }
  
    keyUpSearch(name) {
      const p: any = {}
      p['search'] = name.target.value;
      this.inputElement = name;
      if (name.target.value) {
        this.subject.next(p);
      }
      else {
        this.users = [];
      }
    }
  
    AddFundingOwner(event, role) {
      event.option.value['User_Role'] = role;
      event.option.value['middleName'] = event.option.value.sn;
      if (role === 'Funding_Owner'){
        this.AddSegmentUpdate.FundingOwner.push(event.option.value);
      }
      else {
        this.AddSegmentUpdate.FundingSegment.push(event.option.value);
      }
      let existFlag = false;
      this.EditSegmentData.remove.forEach(row => {
        if ((event.option.value.msid || event.option.value.MSId) === (row.msid || row.MSId) && role === row.role){
          const index = this.EditSegmentData.remove.indexOf(row);
          if (index >= 0) {
            this.EditSegmentData.remove.splice(index, 1);
            existFlag = true;
          }
        }
      })
      if (!existFlag){
        this.EditSegmentData.add.push(event.option.value);
      }
      this.disableAddSegment();
      if (this.inputElement) {
        this.inputElement.target.value = '';
        this.users = []
      }
    }
  
    checkExistUser(user, type, actionType) {
      let tempVar = [];
      if (actionType === 'Edit') {
        if (type === 'Funding_Owner') {
          tempVar = this.AddSegmentUpdate.FundingOwner;
        }
        else {
          tempVar = this.AddSegmentUpdate.FundingSegment;
        }
      }
      let tempBool = false
      tempVar.forEach(archi => {
        if (user.msid === archi.msid) {
          tempBool = true;
        }
      });
      return tempBool;
    }
  
    handleSearch(searchObj) {
      const value = searchObj['search'];
      const column = searchObj['column'];
      console.log('Column', column);
      if (value) {
        this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
          this.users = [];
          dataStream.forEach(element => {
            this.users.push({
              givenName: element.givenName,
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              msid: element.cn,
              middleName: element.middleName,
            });
          });
        }, (error) => {
          console.error(error);
        });
      } else {
        column.options = [];
      }
    }
  
    addSegment() {
      let addSegmentPayload;
      addSegmentPayload = {
        "Funding_Segment": this.fundingSegment.trim(),
        "Funding_Owner": this.AddSegmentUpdate.FundingOwner,
        "Funding_Delegate": this.AddSegmentUpdate.FundingSegment
      }
      this.maintemceService.editSegmentById(addSegmentPayload, this.editSegmentDataSource.Funding_SegmentID).subscribe((data: any) => {
        console.log('Status Data:', data);
        if (Object.keys(data).length > 0) {
          this.toastrService.success('Segment Updated Successfully !', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
          this.SegmentEditById.emit('true');
        }
      }, (error) => {
        console.log('error:', error);
        this.toastrService.error(error?.error?.message, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      })
    }
  
    disableAddSegment() {
      if (this.fundingSegment.trim() != this.editData?.Funding_Segment || this.EditSegmentData.add.length > 0 || this.EditSegmentData.remove.length > 0) {
        this.disableEditSegment = this.fundingSegment.trim() != '' ? false : true;
      } else {
        this.disableEditSegment = true;
      }
    }
  
    focusOnInput(type) {
      if (type === 'addOwner') {
        this.inputAddOwner.nativeElement.focus();
      }
      else if (type === 'addDelegate') {
        this.inputAddDelegate.nativeElement.focus();
      }
    }
  }  
  